// assets/sv-toggle.js
(function () {
  function log(){ try{ console.log.apply(console, ['[SV]'].concat([].slice.call(arguments))); }catch(e){} }

  // Bubliny/tečky, které chceme skrývat (NE video)
  const OVERLAY_SELECTORS = [
    '.shoppable-product-card',
    '.shoppable-video_product',
    '.wt-dot_link',
    '.wt-dot_body',
    '.wt-dot_picture'
  ];

  // Udržujeme, co už je inicializované (po sekcích)
  const inited = new WeakSet();

  // Pomocné – označ overlaye uvnitř určitého scope (sekce)
  function markOverlays(scope){
    (scope || document).querySelectorAll(OVERLAY_SELECTORS.join(','))
      .forEach(el => el.classList.add('sv-overlay'));
  }

  // Vytvoř malé kulaté tlačítko do anchoru (sekční wrapper)
  function createButton(anchor){
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sv-toggle-fixed sv-mini';
    btn.setAttribute('aria-pressed','false');
    btn.setAttribute('aria-label','Skrýt produkty');
    btn.title = 'Skrýt produkty';
    btn.innerHTML = '×';
    anchor.appendChild(btn);
    return btn;
  }

  // Pro jednu sekci: nastav vše (tlačítko, stav, handlery)
  function initForSection(anchor, sec){
    if (!sec || inited.has(sec)) return;
    inited.add(sec);

    // Ať jde v sekci pozicovat absolutně vpravo nahoře
    if (anchor !== document.body && getComputedStyle(anchor).position === 'static') {
      anchor.style.position = 'relative';
    }
    anchor.classList.add('sv-anchor');

    const btn = anchor.querySelector('.sv-toggle-fixed') || createButton(anchor);

    // Klíč pro per-sekční uložení (podle id; když chybí, vygenerujeme)
    if (!sec.id) sec.id = 'sv-sec-' + Math.random().toString(36).slice(2, 8);
    const key = 'svHideProducts-' + sec.id;

    // Označ existující overlaye uvnitř sekce
    markOverlays(sec);

    // Obnov výchozí stav ze storage
    const initialHidden = (() => { try { return localStorage.getItem(key) === '1'; } catch(e){ return false; }})();
    setState(initialHidden);

    // Kliknutí přepíná jen v rámci této sekce
    btn.addEventListener('click', () => {
      const hide = !sec.classList.contains('sv-hidden');
      setState(hide);
    });

    // Lokální setState pro danou sekci
    function setState(hide){
      sec.classList.toggle('sv-hidden', hide);
      btn.setAttribute('aria-pressed', hide ? 'true' : 'false');
      btn.title = hide ? 'Zobrazit produkty' : 'Skrýt produkty';
      btn.setAttribute('aria-label', btn.title);
      try { localStorage.setItem(key, hide ? '1' : '0'); } catch(e){}
      log('[SV] section', sec.id, 'hidden =', hide);
    }
  }

  // Najdi všechny sekce s videem/overlays a inicializuj
  function scanAndInit(){
    const found = [];

    // 1) Přímo wrappery videí
    document.querySelectorAll('.shoppable-video, [class*="shoppable-video"]').forEach(root => {
      const sec = root.closest('[id^="shopify-section"]') || root.closest('[data-section-id]') || document.body;
      found.push({ anchor: root, sec });
    });

    // 2) Pokud na stránce nejsou video wrappery, ale jen overlaye, najdi jejich sekce
    if (!found.length) {
      document.querySelectorAll(OVERLAY_SELECTORS.join(',')).forEach(el => {
        const sec = el.closest('[id^="shopify-section"]') || el.closest('[data-section-id]') || document.body;
        const anchor = sec; // kotva = sekce
        found.push({ anchor, sec });
      });
    }

    // 3) Inicializuj každou jedinečnou sekci
    const seen = new WeakSet();
    found.forEach(({anchor, sec}) => {
      if (!sec || seen.has(sec)) return;
      seen.add(sec);
      initForSection(anchor || sec, sec);
    });
  }

  // Debounce pro mutation observer
  let scanTimer = null;
  function scheduleScan(){
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scanAndInit, 100);
  }

  // Start
  function start(){
    scanAndInit();

    // Sleduj dynamické změny (ajax sekce, lazy load…)
    new MutationObserver(muts => {
      // Při přidání relevantních prvků re-scan
      if (muts.some(m => Array.from(m.addedNodes).some(n =>
        n.nodeType === 1 && (
          n.matches?.('.shoppable-video, [class*="shoppable-video"]') ||
          n.querySelector?.('.shoppable-video, [class*="shoppable-video"]') ||
          n.matches?.(OVERLAY_SELECTORS.join(',')) ||
          n.querySelector?.(OVERLAY_SELECTORS.join(','))
        )
      ))) {
        scheduleScan();
      }
    }).observe(document.documentElement, { childList:true, subtree:true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Shopify Theme Editor události
  document.addEventListener('shopify:section:load', scheduleScan);
  document.addEventListener('shopify:section:select', scheduleScan);
})();
